import { render, staticRenderFns } from "./DeleteInfoDialog.vue?vue&type=template&id=0514e6a3&scoped=true"
import script from "./DeleteInfoDialog.vue?vue&type=script&lang=js"
export * from "./DeleteInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0514e6a3",
  null
  
)

export default component.exports